<script setup lang="ts">
import useModel from './../model/model'
import { VIcons } from '@/shared/ui'

const model = useModel()
</script>

<template>
  <VTooltip :text="$t('itf.set_coords')" location="top">
    <template #activator="{ props }">
      <VIcons v-bind="props" bold type="location_on" @click="model.open = true" />
    </template>
  </VTooltip>
</template>
